export default (form, rules, errorMap) => {
  let errorKey = null
  const error = !Object.keys(rules).every((key) => {
    if (form[key] === null || form[key] === undefined) {
      return true
    }
    const regex = new RegExp(rules[key])
    const pass = regex.test(form[key])
    if (!pass) {
      errorKey = key
    }
    return pass
  })
  return { errorKey, error, errorMessage: errorMap[errorKey] }
}
